/** Images */
import { ReactComponent as HLine } from "../../assets/union.svg";
import FeatureGuy from "../../assets/feature-guy.png";

/** MUI */
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
} from "@mui/material";

/** Components */
import classes from "./featcustomer.module.css";

const FeatCustomer = () => {
    return (
        <Box className={classes.featuresCustomer}>
            <Container maxWidth="xl" disableGutters className={classes.containerFeat}>
                <Grid container spacing={{ xs: 2, xxl: 6 }}>
                    <Grid size={{ xs: 12, md: 7, xl: 7.5, xxl: 8.5 }}>
                        <Box className={classes.subcontent}>
                            <Typography variant="h1" color="V060" className={classes.paddingL}>
                                The features our customers can't live without
                            </Typography>
                            <Box className={classes.svgcontainer}>
                                <HLine />
                            </Box>
                            <Box className={classes.subcontent2}>
                                <Typography variant="body1" color="V060" fontWeight={700}>
                                    One-single email
                                </Typography>
                                <Typography variant="body1" color="V060" className={classes.paddingB}>
                                    Automated document sorting, routing, and posting in the accounting software.
                                </Typography>
                                <Typography variant="body1" color="V060" fontWeight={700}>
                                    5-second conversions
                                </Typography>
                                <Typography variant="body1" color="V060" className={classes.paddingB}>
                                    Instant data extraction from any document, no matter the complexity.
                                </Typography>
                                <Typography variant="body1" color="V060" fontWeight={700}>
                                    Smart posting
                                </Typography>
                                <Typography variant="body1" color="V060">
                                    Transactions' processing based on accounting rationale and history.
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 5, xl: 4.5, xxl: 3.5 }}>
                        <img src={FeatureGuy} alt="Feature Guy" className={classes.featureGuy} />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default FeatCustomer;